import { EntityRequestRwdacct } from "../../entity/EntityRequestRwdacct";

export class DtoRequestRwdacctsPostRes extends EntityRequestRwdacct {}
